import script from "./CategoriaCriarEditar.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriaCriarEditar.vue?vue&type=script&setup=true&lang=js"

import "./CategoriaCriarEditar.vue?vue&type=style&index=0&id=706efbd3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-706efbd3"]])

export default __exports__